import "core-js/modules/es.array.reverse.js";
var _class, _NumberParameter;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable, override } from "mobx";
import FunctionParameter from "./FunctionParameter";
let NumberParameter = (_class = (_NumberParameter = class NumberParameter extends FunctionParameter {
  get rangeDescription() {
    if (this.minimum !== undefined && this.maximum !== undefined) {
      return ": must be between ".concat(this.minimum, " to ").concat(this.maximum);
    } else if (this.minimum !== undefined) {
      return ": at least ".concat(this.minimum);
    } else if (this.maximum !== undefined) {
      return ": at most ".concat(this.maximum);
    } else {
      return "";
    }
  }
  get value() {
    var _super$value;
    return (_super$value = super.value) !== null && _super$value !== void 0 ? _super$value : this.defaultValue;
  }
  get isValid() {
    return super.value === undefined ? this.isValidRange : this.isValidRange && super.isValid;
  }
  get isValidRange() {
    let value = this.value !== undefined ? this.value : this.defaultValue;
    if (typeof value === "string") {
      value = parseFloat(value);
    }
    if (this.minimum !== undefined && value < this.minimum) {
      return false;
    }
    if (this.maximum !== undefined && value > this.maximum) {
      return false;
    }
    return true;
  }
  constructor(catalogFunction, options) {
    super(catalogFunction, options);
    _defineProperty(this, "type", "number");
    _defineProperty(this, "minimum", void 0);
    _defineProperty(this, "maximum", void 0);
    _defineProperty(this, "defaultValue", void 0);
    makeObservable(this);
    this.minimum = options.minimum;
    this.maximum = options.maximum;
    this.defaultValue = options.defaultValue;
  }
}, _defineProperty(_NumberParameter, "type", "number"), _NumberParameter), _applyDecoratedDescriptor(_class.prototype, "rangeDescription", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rangeDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "value", [override], Object.getOwnPropertyDescriptor(_class.prototype, "value"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [override], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _class);
export { NumberParameter as default };